import React, { useContext } from 'react';
import { Box, Typography, Button, CircularProgress, IconButton } from '@mui/material';
import { useTheme } from '@emotion/react';
import { tokens } from '../../../theme';
import { useDispatch } from 'react-redux';
import { DELETE_UNIT } from '../../../Reducers/Actions';
import { useDeleteUnitMutation } from '../../../services/SkillsManagement';
import MuiDialog from '../../../SystemDesign/MuiDialog';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { SnackBarContext } from '../../../Context/SnackBarContextProvider';

const DeleteUnit = ({ open, onClose, unit, onDeleted }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();
  
  // RTK Query deletion hook
  const [deleteUnitMutation, { isLoading }] = useDeleteUnitMutation();
  
  // Access the SnackBar context
  const { setOpenSnackBar, setInfoAlert } = useContext(SnackBarContext);
  
  // Handle unit deletion
  const handleDelete = async () => {
    if (!unit) return;
    
    try {
      // Call API to delete the unit
      await deleteUnitMutation({
        unitId: unit.unit_id
      }).unwrap();
      
      // Update Redux store
      dispatch({ type: DELETE_UNIT, payload: unit.unit_id });
      
      // Show success message
      setInfoAlert({
        severity: 'success',
        message: `Unit "${unit.title || unit.specific_unit || 'Unknown'}" successfully deleted`
      });
      setOpenSnackBar(true);
      
      // Call the onDeleted callback if provided
      if (onDeleted) {
        onDeleted(unit.unit_id);
      }
      
      // Close the dialog
      onClose();
    } catch (error) {
      console.error('Failed to delete unit:', error);
      
      // Show error message
      setInfoAlert({
        severity: 'error',
        message: error?.data?.message || 'Failed to delete unit'
      });
      setOpenSnackBar(true);
    }
  };

  // No need for custom button content, using MuiDialog's built-in action button

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      icon={<DeleteOutlineIcon />}
      title="Delete Unit?"
      subtitle={`Are you sure you want to delete "${unit?.title || unit?.specific_unit || 'Unknown'}"? This action cannot be undone.`}
      maxWidth="xs"
      existAction={true}
      actionTitle="Delete"
      actionFunction={handleDelete}
      isLoading={isLoading}
      actionType="button"
    />
  );
};

export default DeleteUnit;